module.exports = __webpack_public_path__ + "static/media/logo-spotify.b0a5df30.svg";